import React from "react";
const ConfigContext = React.createContext(null);
export default ConfigContext;